import React from "react";
import { Box } from "@mui/system";
import Loader from "components/loader";
import ServicePricingTable from "components/tables/servicePricingTable/Index";
import { useSelector } from "react-redux";
import { ReducersModal } from "utils/modals";

const ServicePricingManagement = () => {
  const { loader, result } = useSelector(
    (state: ReducersModal) => state.ServicePricingReducer
  );

  return (
    <Box>
      <ServicePricingTable />
      {loader && (result.length > 0 || result.length === 0) && <Loader />}
    </Box>
  );
};
export default ServicePricingManagement;
